import i18n from "../i18n";

/**
 * Повертає відображувану назву міста за поточною мовою.
 * @param {string|{ name: string, name_en?: string }|null|undefined} city — назва (рядок) або об'єкт { name, name_en } з API
 * @param {string} [lang] — код мови (uk/en). Якщо не передано, використовується поточна мова i18n.
 * @returns {string}
 */
export function getCityDisplay(city, lang) {
  if (city == null) return "";
  const l = lang ?? (i18n.language && i18n.language.startsWith("en") ? "en" : "uk");
  if (typeof city === "string") return city;
  if (l === "en" && city.name_en) return city.name_en;
  return city.name ?? "";
}

/**
 * Повертає канонічний ключ міста для порівняння (завжди українська назва з API).
 * @param {string|{ name: string, name_en?: string }|null|undefined} city
 * @returns {string}
 */
export function getCityKey(city) {
  if (city == null) return "";
  return typeof city === "string" ? city : (city.name ?? "");
}

/**
 * Перевіряє, чи місто збігається зі значенням пошуку — по name або name_en (регістронезалежно).
 * searchValue може бути рядком (fromCity з форми) або об'єктом міста з API (leg.from_city).
 * @param {string|{ name: string, name_en?: string }|null|undefined} city
 * @param {string|{ name: string, name_en?: string }|null|undefined} searchValue
 * @returns {boolean}
 */
export function cityMatchesSearch(city, searchValue) {
  const searchKey = getCityKey(searchValue);
  if (!searchKey.trim()) return false;

  const key = getCityKey(city);
  const val = searchKey.trim().toLowerCase();
  const nameEn = city && typeof city === "object" ? (city.name_en || "").trim() : "";
  const searchNameEn =
    searchValue && typeof searchValue === "object" ? (searchValue.name_en || "").trim() : "";

  return (
    key.toLowerCase() === val ||
    (nameEn && nameEn.toLowerCase() === val) ||
    (searchNameEn && key.toLowerCase() === searchNameEn.toLowerCase()) ||
    (nameEn && searchNameEn && nameEn.toLowerCase() === searchNameEn.toLowerCase())
  );
}
